import { localStorageService } from '@services'

export type ThemeMode = 'dark' | 'light'

export const changeTheme = (mode: ThemeMode = 'dark'): void => {
  document.getElementsByTagName('body')[0].setAttribute('data-theme', mode)
  localStorageService.updateLocalState({ theme: mode })
}

export const getTheme = (): ThemeMode => {
  return localStorageService.getLocalState()?.theme || 'dark'
}

export const lightColors = [
  'var(--primary500)',
  'var(--tertiary500)',
  'var(--destructive400)',
  'var(--warning500)',
  'var(--success600)',
  'var(--secondary500)',
  'var(--neutral700)',

  'var(--primary400)',
  'var(--tertiary400)',
  'var(--destructive300)',
  'var(--warning400)',
  'var(--success500)',
  'var(--secondary400)',
  'var(--neutral600)',

  'var(--primary300)',
  'var(--tertiary300)',
  'var(--destructive200)',
  'var(--warning300)',
  'var(--success400)',
  'var(--secondary300)',
  'var(--neutral500)',

  'var(--primary200)',
  'var(--tertiary200)',
  'var(--destructive100)',
  'var(--warning200)',
  'var(--success300)',
  'var(--secondary200)',
  'var(--neutral400)',
]

export const darkColors = [
  'var(--primary400)',
  'var(--tertiary400)',
  'var(--destructive300)',
  'var(--warning400)',
  'var(--success500)',
  'var(--secondary400)',
  'var(--neutral100)',

  'var(--primary300)',
  'var(--tertiary300)',
  'var(--destructive200)',
  'var(--warning300)',
  'var(--success400)',
  'var(--secondary300)',
  'var(--neutral200)',

  'var(--primary200)',
  'var(--tertiary200)',
  'var(--destructive100)',
  'var(--warning200)',
  'var(--success300)',
  'var(--secondary200)',
  'var(--neutral300)',

  'var(--primary100)',
  'var(--tertiary100)',
  'var(--destructive050)',
  'var(--warning100)',
  'var(--success200)',
  'var(--secondary100)',
  'var(--neutral400)',
]
const scemanticColors = [
  'var(--chartStocks)',
  'var(--chartEtps)',
  'var(--chartMutualFunds)',
  'var(--chartIndexedFunds)',
  'var(--chartOptions)',
  'var(--chartCrypto)',
  'var(--chartBlackRockFunds)',
]
export const getProductColor = (
  index: number = 0,
  theme: ThemeMode = 'dark',
): string => {
  return scemanticColors[index] ?? getColorByIndex(index, theme)
}

export const getColorByIndex = (
  index: number,
  theme: ThemeMode = 'dark',
): string => {
  const colors = theme === 'light' ? lightColors : darkColors
  return colors[index % colors.length]
}
